<template>
    <!-- <div class="avatar" :style="style"></div> -->
    <div class="avatar" :style="style">
        <b-img :src="imageUrl" class="image"></b-img>
    </div>
</template>
<script>
export default {
    props: {
        photoUrl: {
            type: String,
        },
        width: {
            type: Number,
            default: 100,
        },
        error: {},
        type: {
            type: String,
            default: 'person',
            validator: val => ['person', 'vehicle'].includes(val),
        },
    },
    data: () => ({
        height: 0,
    }),
    computed: {
        imageUrl() {
            const images = {
                person: 'img/generic_user_1.png',
                vehicle: 'img/generic_car.png',
            }
            return !!this.photoUrl ? this.photoUrl : images[this.type]
        },
        style() {
            // const imgUrl = !!this.photoUrl
            //     ? this.photoUrl
            //     : 'img/generic_user.png'
            return {
                width: `${this.width}px`,
                height: `${this.height}px`,
                borderColor: !this.error ? 'lightgray' : 'red',
                // 'background-image': `url(${imgUrl})`,
            }
        },
    },
    watch: {
        photoUrl(val) {
            this.setSize()
        },
    },
    methods: {
        setSize() {
            const img = new Image()
            img.src = this.imageUrl
            const self = this
            img.onload = function() {
                const ratio = this.width / this.height
                const height = self.width / ratio
                self.height = height
            }
        },
    },
    mounted() {
        this.setSize()
    },
}
</script>
<style scoped>
.avatar {
    /* background-position: center;
    background-size: contain;
    background-repeat: no-repeat; */
    /* border-radius: 6px; */
    padding: 3px;
    border: 1px solid;
    border-radius: 6px;
}
.image {
    max-width: 100%;
}
</style>
